import { render, staticRenderFns } from "./weekSelect.vue?vue&type=template&id=2fb12266&scoped=true&"
import script from "./weekSelect.vue?vue&type=script&lang=js&"
export * from "./weekSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb12266",
  null
  
)

export default component.exports